import { render, staticRenderFns } from "./BrandInfo.vue?vue&type=template&id=f0b1f502&scoped=true&"
import script from "./BrandInfo.vue?vue&type=script&lang=ts&"
export * from "./BrandInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BrandInfo.vue?vue&type=style&index=0&id=f0b1f502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b1f502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VImg,VRow})
